import { getApiBaseUrl, handleApiError } from '../../core/config/api';
import { UserWithRole } from './userService';

class UserProfileService {
  private getAuthToken(): string | null {
    const token = localStorage.getItem('token') || localStorage.getItem('authToken');
    return token;
  }

  private async fetchWithAuth(url: string, options: RequestInit = {}): Promise<Response> {
    const token = this.getAuthToken();
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      ...(options.headers as Record<string, string> || {}),
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    return fetch(url, {
      ...options,
      headers,
    });
  }

  /**
   * Change le mot de passe de l'utilisateur connecté
   */
  async changePassword(
    currentPassword: string,
    newPassword: string
  ): Promise<{
    success: boolean;
    message: string;
    error?: string;
  }> {
    try {
      const url = `${getApiBaseUrl(true)}/users/me/password`;
      const response = await this.fetchWithAuth(url, {
        method: 'PATCH',
        body: JSON.stringify({ currentPassword, newPassword }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `Erreur HTTP: ${response.status}`);
      }

      return await response.json();
    } catch (error: any) {
      throw new Error(handleApiError(error));
    }
  }

  /**
   * Change l'email de l'utilisateur connecté
   */
  async changeEmail(
    newEmail: string,
    password: string
  ): Promise<{
    success: boolean;
    message: string;
    data?: UserWithRole;
    error?: string;
  }> {
    try {
      const url = `${getApiBaseUrl(true)}/users/me/email`;
      const response = await this.fetchWithAuth(url, {
        method: 'PATCH',
        body: JSON.stringify({ newEmail, password }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `Erreur HTTP: ${response.status}`);
      }

      return await response.json();
    } catch (error: any) {
      throw new Error(handleApiError(error));
    }
  }
}

const userProfileService = new UserProfileService();
export default userProfileService;

